import { ajax } from "../lib/observable";
import siteConfig from "../site-config";
import { stringify } from "querystring";
import { Observable } from "rxjs";
import { BRAND_SIZE_OVERRIDES, SIZE_FAMILIES } from "../constants/action-types";
import { add as snackbarAdd } from "../actions/snackbars";
import { formatMessage } from "lib/globalize-util";

export const fetchBrandSizeOverridesEpic = (action$, store) =>
    action$
        .ofType(BRAND_SIZE_OVERRIDES.FETCH.START)
        .map((action) => action.payload)
        .concatMap(() => {
            const query = {
                __limit: 1000,
            };
            return ajax(`${siteConfig.api}/api/v3.0/items/brand-sizes/overrides?${stringify(query)}`)
                .map(({ response }) => {
                    return { overrides: response };
                })
                .flatMap(({ overrides }) => {
                    const queryParams = {
                        __limit: 999, // limit on the controller is from 1 to 1000, so to make it a little bit more stable
                        // not to pass direct edge-case limit
                    };
                    return ajax(`${siteConfig.api}/api/v3.0/items/sizes/families?${stringify(queryParams)}`).map(
                        ({ response }) => {
                            const families = response
                                .slice()
                                .sort((f1, f2) => f1.name.toLowerCase().localeCompare(f2.name));
                            return {
                                overrides,
                                families,
                            };
                        },
                    );
                })
                .catch((error) =>
                    Observable.merge(
                        Observable.of({
                            error: true,
                            payload: error,
                            type: BRAND_SIZE_OVERRIDES.FETCH.SUCCESS,
                        }),
                        Observable.of(
                            snackbarAdd({ message: formatMessage("There was an error fetching brand size overrides") }),
                        ),
                    ),
                );
        })
        .flatMap(({ overrides, families }) => [
            {
                payload: families,
                type: SIZE_FAMILIES.FETCH.SUCCESS,
            },
            {
                payload: overrides,
                type: BRAND_SIZE_OVERRIDES.FETCH.SUCCESS,
            },
        ])
        .catch((error) =>
            Observable.merge(
                Observable.of({
                    error: true,
                    payload: error,
                    type: BRAND_SIZE_OVERRIDES.FETCH.SUCCESS,
                }),
                Observable.of(
                    snackbarAdd({ message: formatMessage("There was an error fetching brand size overrides") }),
                ),
            ),
        );

export const updateBrandSizeOverridesEpic = (action$, store) =>
    action$
        .ofType(BRAND_SIZE_OVERRIDES.UPDATE.START)
        .map((action) => {
            return action.payload;
        })
        .concatMap((sizeOverride) => {
            const { _id } = sizeOverride;
            return ajax({
                method: "PUT",
                body: sizeOverride,
                url: `${siteConfig.api}/api/v3.0/items/brand-sizes/overrides/${_id}`,
            })
                .flatMap(({ response }) => [
                    {
                        payload: response,
                        type: BRAND_SIZE_OVERRIDES.UPDATE.COMPLETED,
                    },
                ])
                .catch((error) =>
                    Observable.merge(
                        Observable.of({
                            error: true,
                            payload: error,
                            type: BRAND_SIZE_OVERRIDES.UPDATE.COMPLETED,
                        }),
                        Observable.of(
                            snackbarAdd({ message: formatMessage("There was an error updating brand size overrides") }),
                        ),
                    ),
                );
        });

export const createBrandSizeOverrideEpic = (action$, store) =>
    action$
        .ofType(BRAND_SIZE_OVERRIDES.CREATE.START)
        .map((action) => {
            return action.payload;
        })
        .concatMap((sizeFamily) => {
            return ajax({
                method: "POST",
                body: sizeFamily,
                url: `${siteConfig.api}/api/v3.0/items/brand-sizes/overrides`,
            })
                .flatMap(({ response }) => [
                    {
                        payload: response,
                        type: BRAND_SIZE_OVERRIDES.CREATE.COMPLETED,
                    },
                ])
                .catch((error) =>
                    Observable.merge(
                        Observable.of({
                            error: true,
                            payload: error,
                            type: BRAND_SIZE_OVERRIDES.CREATE.COMPLETED,
                        }),
                        Observable.of(
                            snackbarAdd({ message: formatMessage("There was an error creating brand size override") }),
                        ),
                    ),
                );
        });

export const deleteBrandSizeOverrideEpic = (action$, store) =>
    action$
        .ofType(BRAND_SIZE_OVERRIDES.DELETE.START)
        .map((action) => {
            return action.payload;
        })
        .concatMap((id) => {
            return ajax({
                url: `${siteConfig.api}/api/v3.0/items/brand-sizes/overrides/${id}`,
                method: "DELETE",
            })
                .flatMap(({ response }) => {
                    return [
                        {
                            payload: response,
                            type: BRAND_SIZE_OVERRIDES.DELETE.COMPLETED,
                        },
                    ];
                })
                .catch((error) => {
                    return Observable.merge(
                        Observable.of({
                            error: true,
                            payload: error,
                            type: BRAND_SIZE_OVERRIDES.DELETE.COMPLETED,
                        }),
                        Observable.of(
                            snackbarAdd({ message: formatMessage("There was an error deleting size override") }),
                        ),
                    );
                });
        });
